module.exports = __webpack_public_path__ + "assets/734d572710a412c8c9e177bb01190981.png";